module.exports = __webpack_public_path__ + "static/icons/icon-caret-down-a2e5a4a56c1826948dad05f520f0fd54.svg";